// extracted by mini-css-extract-plugin
module.exports = {"textAreaBox":"TextArea_textAreaBox__2H_rv","textAreaLabel":"TextArea_textAreaLabel__3r__r","textAreaWrap":"TextArea_textAreaWrap__2vFvf"};